/**
 * 选择主体（传统 CV 路线，DESIGN.md §6.2/§2.11 相关，不含 AI/ONNX）。
 *
 * 跟 `selection-grow.ts` 同款模式，但不需要"已有选区"这个前提——
 * 选区是应用层会话状态，不进 Command Bus、不进历史。
 */
import { selectSubject } from '../engine/selection/select-subject';
import { compositeDocument } from './composite';
import type { AppStore } from './store';

/** 选择主体。无文档时什么都不做，返回 false。 */
export async function selectSubjectAction(store: AppStore): Promise<boolean> {
  const document = store.document;
  if (document === null) return false;
  const composite = compositeDocument(document, store.tiles);
  store.setSelection(await selectSubject(composite));
  return true;
}
